const BASE_URL = `${process.env.VUE_APP_OSS_URL}/audio/common/`

const TP = {
  BUTTON: 'BUTTON',
  CHAT: 'CHAT',
  PLAYCOME: 'PLAYCOME',
}

function getSoundEffectUrl (audioName) {
  return BASE_URL + `${audioName}.mp3`
}

export {
  TP,
  getSoundEffectUrl
}
